module.exports = __webpack_public_path__ + "img/activeSet4.bf6a990a.png";